import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ENV } from '../../config/config';
import { beforeSizeGroup, getSizeGroups, addSizeGroup, editSizeGroup, deleteSizeGroup } from './SizeGroup.action';
import FullPageLoader from 'components/FullPageLoader/FullPageLoader';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import Swal from 'sweetalert2';
import { getRole } from 'views/AdminStaff/permissions/permissions.actions';
import { Button, Card, Form, Table, Container, Row, Col, Modal } from "react-bootstrap";
import { valuesToCommaSeparatedLabels } from '../../../src/utils/functions'
import Select from 'react-select'
var CryptoJS = require("crypto-js");

const SizeGroups = (props) => {
    const [data, setData] = useState(null)
    const [pagination, setPagination] = useState(null)
    const [Page, setPage] = useState(1)
    const [loader, setLoader] = useState(true)
    const [permissions, setPermissions] = useState({})
    const [sizeGroup, setSizeGroup] = useState(null)
    const [msg, setMsg] = useState({
        height: '',
        width: '',
        blackAndWhitePrice: '',
        coloredPrice: '',
        mixedPrice: '',
    })
    const [modal, setModal] = useState(false)
    const [modalType, setModalType] = useState(false)       // 0: Add 1: View 2: Edit

    // Define an array of options with values and labels for body part
    const options = [
        { value: 1, label: 'Left Arm' },
        { value: 2, label: 'Right Arm' },
        { value: 3, label: 'Chest' },
        { value: 4, label: 'Neck' },
        { value: 5, label: 'Back' },
        { value: 6, label: 'Left Leg' },
        { value: 7, label: 'Right Leg' },
        { value: 8, label: 'Wrist' },
    ];

    // Function to handle changes in the selected body parts
    const handleSelectChange = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
        setSizeGroup({ ...sizeGroup, bodyParts: selectedValues });


    }


    useEffect(() => {
        window.scroll(0, 0)
        const qs = ENV.objectToQueryString({ page: Page, limit: 10 })
        const filter = {}
        props.getSizeGroups(qs, filter)
        let roleEncrypted = localStorage.getItem('role');
        let role = ''
        if (roleEncrypted) {
            let roleDecrypted = CryptoJS.AES.decrypt(roleEncrypted, 'secret key 123').toString(CryptoJS.enc.Utf8);
            role = roleDecrypted
        }
        props.getRole(role)
    }, [])

    useEffect(() => {
        if (Object.keys(props.getRoleRes).length > 0) {
            setPermissions(props.getRoleRes.role)
        }
    }, [props.getRoleRes])                          // Roles Fetched

    useEffect(() => {
        if (props.sizeGroups.getSizeGroupsAuth) {
            let { sizeGroups, pagination } = props.sizeGroups.sizeGroups
            setData(sizeGroups)
            setLoader(false)
            setPagination(pagination)
            setModal(false)
            props.beforeSizeGroup()
        }
    }, [props.sizeGroups.getSizeGroupsAuth])        // Size Groups Fetched                

    useEffect(() => {
        if (props.sizeGroups.createAuth || props.sizeGroups.editSizeGroupAuth || props.sizeGroups.delSizeGroupAuth) {
            const qs = ENV.objectToQueryString({ page: Page, limit: 10 })
            const filter = {}
            props.getSizeGroups(qs, filter)
        }
    }, [props.sizeGroups.createAuth, props.sizeGroups.editSizeGroupAuth, props.sizeGroups.delSizeGroupAuth])         // Size Group Created, Deleted

    const deleteSizeGroup = (sizeGroupId) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            html: 'If you delete an item, it would be permanently lost.',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }).then(async (result) => {
            if (result.value) {
                setLoader(true)
                props.deleteSizeGroup(sizeGroupId)
            }
        })
    }

    const onPageChange = async (page) => {
        const filter = {}
        setPage(page)
        setLoader(true)
        const qs = ENV.objectToQueryString({ page: page, limit: 10 })
        props.getSizeGroups(qs, filter)
    }

    const initialModalData = (item = null) => {

        if (item == null) {
            setSizeGroup({
                height: '',
                width: '',
                blackAndWhitePrice: '',
                coloredPrice: '',
                mixedPrice: '',
                bodyParts: [],
            })
        } else {
            setSizeGroup({
                _id: item._id,
                height: item.height,
                width: item.width,
                blackAndWhitePrice: item.blackAndWhitePrice,
                coloredPrice: item.coloredPrice,
                mixedPrice: item.mixedPrice,
                bodyParts: item.bodyParts,

            })

        }
        setMsg({
            height: '',
            width: '',
            blackAndWhitePrice: '',
            coloredPrice: '',
            mixedPrice: '',
        })

    }

    const setFormModal = (type, item = null) => {
        initialModalData(item)
        setModal(!modal)
        setModalType(type)
    }

    const submitForm = () => {
        setMsg({
            height: sizeGroup?.height ? '' : "Height is required",
            width: sizeGroup?.width ? '' : "Width is required",
            blackAndWhitePrice: sizeGroup?.blackAndWhitePrice ? '' : "Black & White price is required",
            coloredPrice: sizeGroup?.coloredPrice ? '' : "Colored price is required",
            mixedPrice: sizeGroup?.mixedPrice ? '' : "Mixed price is required",
        })
        if (sizeGroup.height && sizeGroup.width && sizeGroup.blackAndWhitePrice && sizeGroup.coloredPrice && sizeGroup.mixedPrice) {

            sizeGroup.bodyParts = Array.isArray(sizeGroup.bodyParts) ? sizeGroup.bodyParts : [];
            if (modalType == 0) { // Create New
                props.addSizeGroup({ ...sizeGroup })
            }
            else if (modalType == 2) { // Update Old
                props.editSizeGroup({ ...sizeGroup })
            }
        }
    }


    return (
        <>
            {
                loader ?
                    <FullPageLoader />
                    :
                    <Container fluid>
                        <Row className="pb-3">
                            <Col md="12">
                                <Card className="table-big-boy">
                                    <Card.Header>
                                        <div className='d-flex justify-content-end mb-2 pr-3'>
                                            <span style={{ color: 'black', fontWeight: 'bold' }}>{`Total : ${pagination?.total}`}</span>
                                        </div>
                                        <div className="d-block d-md-flex align-items-center justify-content-between">
                                            <Card.Title as="h4">Size Groups</Card.Title>
                                            {
                                                permissions && permissions.addSizeGroup &&
                                                <Button
                                                    variant="info"
                                                    className="float-sm-right"
                                                    onClick={() => setFormModal(0)}>
                                                    Add Size Group
                                                </Button>
                                            }
                                        </div>
                                    </Card.Header>
                                    <Card.Body className="table-full-width">
                                        <div className="table-responsive">
                                            <Table className="table-bigboy">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center serial-col">#</th>
                                                        <th className='text-center'>Height</th>
                                                        <th className='text-center'>Width</th>
                                                        <th className='text-center'>Body Parts</th>
                                                        <th className='text-center'>Prices</th>
                                                        <th className="text-center td-actions">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length ?
                                                            data.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="text-center serial-col">{pagination && ((pagination.limit * pagination.page) - pagination.limit) + index + 1}</td>
                                                                        <td className="text-center">
                                                                            {item.height}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {item.width}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {item?.bodyParts?.length > 0 && valuesToCommaSeparatedLabels(item?.bodyParts, options)}
                                                                        </td>
                                                                        <td className="text-center ">
                                                                            <p className="m-0">Black & White: {item.blackAndWhitePrice}</p>
                                                                            <p className="m-0">Colored: {item.coloredPrice}</p>
                                                                            <p className="m-0">Mixed: {item.mixedPrice}</p>
                                                                        </td>
                                                                        <td className="td-actions text-center">
                                                                            <ul className="list-unstyled mb-0">
                                                                                <li className="d-inline-block align-top">
                                                                                    <Button
                                                                                        className="btn-action btn-primary"
                                                                                        type="button" title="View"
                                                                                        onClick={() => setFormModal(1, item)}
                                                                                    >
                                                                                        <i className="fa fa-eye"></i>
                                                                                    </Button>
                                                                                </li>

                                                                                {
                                                                                    permissions && permissions.editSizeGroup &&
                                                                                    <li className="d-inline-block align-top">
                                                                                        <Button
                                                                                            className="btn-action btn-warning"
                                                                                            type="button" title="Edit"
                                                                                            variant="success"
                                                                                            onClick={() => setFormModal(2, item)}
                                                                                        >
                                                                                            <i className="fas fa-edit"></i>
                                                                                        </Button>
                                                                                    </li>
                                                                                }
                                                                                {
                                                                                    permissions && permissions.deleteSizeGroup &&
                                                                                    <li className="d-inline-block align-top">
                                                                                        <Button
                                                                                            className="btn-action btn-danger"
                                                                                            type="button"
                                                                                            variant="danger" title="Delete"
                                                                                            onClick={() => deleteSizeGroup(item._id)}
                                                                                        >
                                                                                            <i className="fas fa-trash"></i>
                                                                                        </Button>
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    <div className="alert alert-info" role="alert">No Size Group Found</div>
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                            {
                                                pagination &&
                                                <Pagination
                                                    className="m-3"
                                                    defaultCurrent={1}
                                                    pageSize // items per page
                                                    current={Page > pagination.pages ? pagination.pages : Page} // current active page
                                                    total={pagination.pages} // total pages
                                                    onChange={onPageChange}
                                                    locale={localeInfo}
                                                />
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {
                            modal &&
                            <Modal className="modal-primary" id="content-Modal" onHide={() => setModal(!modal)} show={modal}>
                                <Modal.Header className="justify-content-center">
                                    <Row>
                                        <div className="col-12">
                                            <h4 className="mb-0 mb-md-3 mt-0">
                                            {modalType == 0 ? "Add " : "Edit "}
                                                 Size Group
                                            </h4>
                                        </div>
                                    </Row>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <label>Height <span className="text-danger">*</span></label>
                                                    {modalType == 1 ?
                                                        <Form.Control
                                                            readOnly
                                                            type="number"
                                                            value={sizeGroup.height}
                                                            
                                                        />
                                                        :
                                                        <>
                                                            <Form.Control
                                                                type="number"
                                                                value={sizeGroup.height}
                                                                onChange={(event) => setSizeGroup({ ...sizeGroup, height: event.target.value })}
                                                                onInput={() => setMsg((prevMsg) => ({ ...prevMsg, height: '' }))}
                                                                min={0} 
                                                            />
                                                            <span className={msg.height ? `` : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.height}</small>
                                                            </span>
                                                        </>
                                                    }
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <label>Width <span className="text-danger">*</span></label>
                                                    {modalType == 1 ?
                                                        <Form.Control
                                                            readOnly
                                                            type="number"
                                                            value={sizeGroup.width}
                                                        />
                                                        :
                                                        <>
                                                            <Form.Control
                                                                type="number"
                                                                value={sizeGroup.width}
                                                                onChange={(event) => setSizeGroup({ ...sizeGroup, width: event.target.value })}
                                                                onInput={() => setMsg((prevMsg) => ({ ...prevMsg, width: '' }))}
                                                                min={0} 
                                                            />
                                                            <span className={msg.width ? `` : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.width}</small>
                                                            </span>
                                                        </>
                                                    }
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <h4 style={{ "color": "white" }}>Prices <span className="text-danger">*</span></h4>
                                                <Form.Group>
                                                    <label>Black & White <span className="text-danger">*</span></label>
                                                    {modalType == 1 ?
                                                        <Form.Control
                                                            readOnly
                                                            type="number"
                                                            value={sizeGroup.blackAndWhitePrice}
                                                        />
                                                        :
                                                        <>
                                                            <Form.Control
                                                                type="number"
                                                                value={sizeGroup.blackAndWhitePrice}
                                                                onChange={(event) => setSizeGroup({ ...sizeGroup, blackAndWhitePrice: event.target.value })}
                                                                onInput={() => setMsg((prevMsg) => ({ ...prevMsg, blackAndWhitePrice: '' }))}
                                                                min={0} 
                                                            />
                                                            <span className={msg.blackAndWhitePrice ? `` : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.blackAndWhitePrice}</small>
                                                            </span>
                                                        </>
                                                    }
                                                    <br /><label>Colored <span className="text-danger">*</span></label>
                                                    {modalType == 1 ?
                                                        <Form.Control
                                                            readOnly
                                                            type="number"
                                                            value={sizeGroup.coloredPrice}
                                                        />
                                                        :
                                                        <>
                                                            <Form.Control
                                                                type="number"
                                                                value={sizeGroup.coloredPrice}
                                                                onChange={(event) => setSizeGroup({ ...sizeGroup, coloredPrice: event.target.value })}
                                                                onInput={() => setMsg((prevMsg) => ({ ...prevMsg, coloredPrice: '' }))}
                                                                min={0} 
                                                            />
                                                            <span className={msg.coloredPrice ? `` : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.coloredPrice}</small>
                                                            </span>
                                                        </>
                                                    }
                                                    <br /><label>Mixed <span className="text-danger">*</span></label>
                                                    {modalType == 1 ?
                                                        <Form.Control
                                                            readOnly
                                                            type="number"
                                                            value={sizeGroup.mixedPrice}
                                                        />
                                                        :
                                                        <>
                                                            <Form.Control
                                                                type="number"
                                                                value={sizeGroup.mixedPrice}
                                                                onChange={(event) => setSizeGroup({ ...sizeGroup, mixedPrice: event.target.value })}
                                                                onInput={() => setMsg((prevMsg) => ({ ...prevMsg, mixedPrice: '' }))}
                                                                min={0} 
                                                            />
                                                            <span className={msg.mixedPrice ? '' : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.mixedPrice}</small>
                                                            </span>
                                                        </>
                                                    }
                                                </Form.Group>
                                            </Col>

                                            <Col md={12}>
                                                <Form.Group>
                                                    <label>Body Parts </label>
                                                    {modalType == 1 ?
                                                        <p>
                                                            <label>{sizeGroup?.bodyParts?.length > 0 && valuesToCommaSeparatedLabels(sizeGroup.bodyParts, options)}</label>
                                                        </p>
                                                        :
                                                        <>
                                                            <Select
                                                                isMulti
                                                                options={options}
                                                                value={
                                                                    Array.isArray(sizeGroup?.bodyParts) ?
                                                                        sizeGroup.bodyParts.map((value) => options.find((option) => option.value === value))
                                                                        : []}
                                                                onChange={handleSelectChange}
                                                            />
                                                            <span className={msg.bodyParts ? `` : `d-none`}>
                                                                <small className="pl-1 text-danger">{msg.bodyParts}</small>
                                                            </span>
                                                        </>
                                                    }
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    {modalType != 1 && <Button className="btn btn-success" onClick={() => submitForm()}>{modalType == 0 ? "Add" : "Update"}</Button>}
                                    <Button className="btn btn-danger" onClick={() => setModal(!modal)}>Close</Button>
                                </Modal.Footer>
                            </Modal>
                        }
                    </Container>
            }
        </>
    )
}

const mapStateToProps = state => ({
    sizeGroups: state.sizeGroups,
    error: state.error,
    getRoleRes: state.role.getRoleRes
});

export default connect(mapStateToProps, { beforeSizeGroup, getSizeGroups, addSizeGroup, editSizeGroup, deleteSizeGroup, getRole })(SizeGroups);